import { createStructuredSelector } from "reselect";
import {
    AWARD_LIST,
    AWARD_LIST_SUCCESS,
    AWARD_LIST_ERROR,
    AWARD_PAGE_SET,
    AWARD_HEADER,
    AWARD_SEARCH_SET,
    AWARD_SEARCH_CHANGE
} from "../actions";

export const NAME = 'award';

export const AwardList = (page, num_page, orderBy, filters, stateFilter) => ({
    type: AWARD_LIST,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const AwardListSuccess = (data) => ({
    type: AWARD_LIST_SUCCESS,
    payload: data
});

export const AwardListError = (error) => ({
    type: AWARD_LIST_ERROR,
    payload: error
});

export const AwardPageSet = (data) => ({
    type: AWARD_PAGE_SET,
    payload: data
});

export const AwardHeader = (data) => ({
    type: AWARD_HEADER,
    payload: data
})

export const AwardSearchSet = (data) => ({
    type: AWARD_SEARCH_SET,
    payload: data
});

export const AwardSearchChangeSet = (data) => ({
    type: AWARD_SEARCH_CHANGE,
    payload: data
});

const award = (state) => state[NAME];

export const AwardSelector = createStructuredSelector({
    award
})
